module.exports = __webpack_public_path__ + "static/service04-b3c6d71647bd0c6e3e13f4ddb8f19a04.png";